import React, { useState } from "react";
import { Button, Dropdown, DropdownProps, Grid, Input, Label, Modal, Segment } from "semantic-ui-react";
import config from "../../../common/repository/config";
import LocalStorage from "../../../lib/LocalStorage";
import { toast } from "../../common/Toast";

interface DropdownOption {
    key: string;
    text: string;
    value: string;
}
interface RemarksProps {
    open: boolean;
    onClose: () => void;
    typeId: string;
    userId: string;
    remark: string
    message: string;
    title: string;
    metadata: {
        call_date: string;
        call_time: string;
        receiver_name: string;
        receiver_number: string;
        receiver_role: string;
    };
}
const options: DropdownOption[] = [
    { key: "wrong_number", text: "Wrong Number", value: "wrong_number" },
    { key: "non_cooperative", text: "Insured Non Cooperative", value: "non_cooperative" },
    { key: "meeting_no_address", text: "Agreed for Meeting but Address not Confirm", value: "meeting_no_address" },
    { key: "meeting_address_confirm", text: "Agreed for Meeting and Address Confirm", value: "meeting_address_confirm" },
    { key: "delaying_meeting", text: "Delaying for Meeting", value: "delaying_meeting" },
    { key: "denied_documents", text: "Denied to provide Documents/Details", value: "denied_documents" },
    { key: "other", text: "Other", value: "other" }
];
const Remarks: React.FC<RemarksProps> = ({ open, onClose, typeId, userId, metadata, title, message }) => {
    const [selectedValue, setSelectedValue] = useState<string | undefined>(undefined);
    const [addRemark, setAddRemark] = useState("");

    const handleChange = (_: React.SyntheticEvent, data: DropdownProps) => {
        setSelectedValue(data.value as string);
    };
    const handleSubmit = async () => {
        if (!selectedValue) {
            toast.error("Please select a remark");
            return;
        }
        const selectedOption = options.find(option => option.value === selectedValue);
        const remarkText = selectedValue === "other" ? addRemark.trim() : selectedOption?.text || "";
        if (selectedValue === "other" && !remarkText) {
            toast.error("Please Select a remark.");
            return;
        }
        try {
            const token = LocalStorage.get(LocalStorage.KEY_AUTH_TOKEN);
            if (!token) {
                console.error("Authentication token is missing.");
                return;
            }
            const payload = {
                userId,
                typeId,
                remark: remarkText
            };
            const response = await fetch(`${config.apiBaseURL}/case/recRemark`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "x-access-token": token,
                },
                body: JSON.stringify(payload),
            });
            if (response.ok) {
                toast.success("Remark added successfully");
            }
            onClose();
        } catch (error) {
            console.error("Error submitting remark:", error);
        }
    }
    return (
        <Modal open={open} onClose={onClose} size="tiny" centered style={{ textAlign: "center" }}>
            <Modal.Header style={{ fontSize: "18px", fontWeight: "bold" }}>{title}</Modal.Header>
            <Modal.Content>
                <p><strong>{message}</strong></p>
                <div style={{ padding: "10px", borderRadius: "5px", background: "#f9f9f9" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "5px" }}>
                        <p><strong>Receiver Name:</strong> {metadata.receiver_name}</p>
                        <p><strong>Receiver Role:</strong> {metadata.receiver_role}</p>
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "5px" }}>
                        <p><strong>Call Date:</strong> {metadata.call_date}</p>
                        <p><strong>Call Time:</strong> {metadata.call_time}</p>
                    </div>
                </div>
                <Dropdown
                    placeholder="Select Remark"
                    fluid
                    selection
                    options={options}
                    value={selectedValue}
                    onChange={handleChange}
                    style={{ marginBottom: "10px" }}
                />
                {selectedValue === "other" && (
                    <Input
                        fluid
                        placeholder="Enter your remark..."
                        value={addRemark}
                        onChange={(e) => setAddRemark(e.target.value)}
                        style={{ marginBottom: "10px", padding: "8px" }}
                    />
                )}
            </Modal.Content>
            <Modal.Actions>
                <Button onClick={onClose} style={{ backgroundColor: "#f4f4f4", color: "#333" }}>Cancel</Button>
                <Button primary onClick={handleSubmit} style={{ backgroundColor: "#2185d0", color: "white" }}>Submit</Button>
            </Modal.Actions>
        </Modal>
    );
};
export default Remarks;